<sb-card [singleHeight]="true">
  <div card-header classes="no-border">
    <h3>{{ 'lang.globals.inventory' | translate }}</h3>
  </div>
  <div card-fit>
    <div class="px-4">
      <!--
      <div class="inventory-padding" style="padding-top: 2rem;">
         //comment
         <div class="row mb-3">


          <div class="col">
            <label for="selectATimespan">{{'lang.globals.timespan' | translate}}
            </label>
            <sb-local-date-time-range-input
              id="selectATimespan"
              [from]="from" [till]="till"
              (dateChange)="handleDateChange($event)"></sb-local-date-time-range-input>
          </div>
        </div>
        // comment end
        <div class="row mb-3">
          <div class="col">
            <sb-local-date-time-input id="From" [title]="translate.instant('lang.globals.startTime')" [seconds]="false"
                                      [kind]="'RANGE_START'" [initialDate]="from"
                                      (modelChange)="handleDateChange($event, 'from')">
            </sb-local-date-time-input>
          </div>
          <div class="col">
            <sb-local-date-time-input id="Till" [title]="translate.instant('lang.globals.dueTime')" [seconds]="false"
                                      [kind]="'RANGE_END'" [initialDate]="till"
                                      (modelChange)="handleDateChange($event, 'till')">
            </sb-local-date-time-input>
          </div>
        </div>
        <div class="row mb-2 mt-5">
          <div class="col pr-1">
            <label class="form-label" for="TargetingAmount">{{'lang.globals.amount' | translate}}</label>
            <input id="TargetingAmount" type="number" class="form-control text-end" [(ngModel)]="amount"
                   (ngModelChange)="requestPriceDebounced()"/>
          </div>
          <div class="col px-1">
            <label class="form-label" for="DurationPerPlayout">{{'lang.globals.playoutDuration' | translate}}</label>
            <input id="DurationPerPlayout" type="number" class="form-control text-end"
                   [(ngModel)]="durationPerPlayout"
                   (ngModelChange)="requestPriceDebounced()"/>
          </div>
          <div class="col pl-1">
            <label class="form-label" for="TargetingRelation">{{'lang.targeting.relation' | translate}}</label>
            <select id="TargetingRelation" class="form-select" [(ngModel)]="selectedTimingRelation"
                    (ngModelChange)="requestPriceDebounced()">
              <option *ngFor="let relation of timingRelations" [ngValue]="relation">
                {{'lang.targetingAndBudget.timingRelations.' + relation | translate}}
              </option>
            </select>
          </div>
        </div>
      </div>
      -->
      <h5 class="text-uppercase inventory-padding"
          style="padding-top: 2rem;">{{ 'lang.globals.selected' | translate }}<span class="red">*</span></h5>
      <div class="table-responsive inventory-padding" style="padding-bottom: 2rem; padding-top: 2rem;">
        <ng-scrollbar style="height: 250px">
          <table class="table">
            <thead>
            <tr>
              <th class="pl-0 font-weight-bold text-muted text-uppercase">{{ 'lang.globals.type' | translate }}</th>
              <th class="font-weight-bold text-muted text-uppercase">{{ 'lang.globals.element' | translate }}</th>
              <th class="font-weight-bold text-muted text-uppercase">{{ 'lang.globals.overview' | translate }}</th>
              <!-- <th class="pr-0 text-end font-weight-bold text-muted text-uppercase">{{'lang.globals.price' | translate}}</th> -->
              <th></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="cartFilter && cartFilter.length > 0">
              <tr *ngFor="let values of cartFilter">
                <ng-container *ngFor="let fil of values.values">
                  <td class="text-start pl-0">{{ translate.instant('lang.inventory.' + values.path.type) }}</td>
                  <td class="text-start">
                    <span>{{ fil.displayValue.name }}</span>
                  </td>
                  <td class="text-end">
                    <sb-aggregation-report [showCaption]="false" [aggregatedData]="fil.report"></sb-aggregation-report>
                  </td>
                  <td class="text-end">
                    <button class="btn btn-danger" (click)="removeFromCart.emit(values)">
                      <sb-icon icon="trash"></sb-icon>
                    </button>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
            <ng-container *ngIf="cartFilter && cartFilter.length === 0">
              <tr>
                <td colspan="4" style="text-align: center;padding: 2rem;">
                  <h5>{{ 'lang.globals.noElementsInCart' | translate }}</h5>
                </td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </ng-scrollbar>
        <!--
        <hr style="margin-bottom: .4rem;">
        <hr style="margin-top: .4rem;">
        <div class="d-flex justify-content-end text-end">
          <div class="text-end">
            <h4>
              {{ 'lang.globals.runningScreens' | translate }} {{ selectedScreens.length | sbNumberFormat }}
            </h4>
            <h3
              (click)="resolveScreenPrice()">{{ 'lang.globals.priceSumInEUR' | translate }} {{ calculatedSum | sbNumberFormat }}</h3>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
  <div card-footer>
    <form [formGroup]="form" *ngIf="this.modalType !== 'cullEdit'">
      <div class="d-flex justify-content-between align-items-center my-3">
        <div class="form-group">
          <label class="form-label" for="FilterTitle">{{ 'lang.globals.name' | translate }}<span class="red">*</span></label>
          <input type="text" id="FilterTitle" class="form-control" [ngModel]="cull?.name"
                 (ngModelChange)="setValue('name', $event)" [ngModelOptions]="{standalone: true}">
          <!--            <div *ngIf="Name.touched && Name.errors?.required"
                           class="alert alert-danger">{{'lang.globals.nameWarning' | translate}}</div>-->
        </div>
        <button [disabled]="isCreationPossible()" (click)="convertToPlayerCull()"
                class="btn btn-primary">{{ 'lang.globals.saveInventorySelection' | translate }}
        </button>
      </div>
    </form>
    <button class="btn btn-primary " *ngIf="this.modalType === 'cullEdit'"
            (click)="addToCull()">{{ 'lang.globals.addScreensToCull' | translate }}
    </button>
  </div>
</sb-card>
